import { Typography } from '@material-ui/core';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { SettingsCard } from '@vyce/core/src/components/SettingsCard';
import { SafeDndProvider } from '@vyce/core/src/components/SafeDndProvider';

import { useStyles } from './styles';
import { useData } from './hooks';
import { Props } from './types';
import { CustomDetailsFieldsProvider, BlockOfFields, DeleteDialog } from './components';

/* 
  Module for Custom Location Details Fields in T&A settings page
*/

export const CustomDetailsFieldsModule = (props: Props) => {
  const classes = useStyles();

  const {
    defaultFields,
    customFields,
    contextOptions,
    showDeleteDialog,
    fieldName,
    closeDeleteDialog,
    deleteCustomField,
  } = useData(props);

  return (
    <CustomDetailsFieldsProvider value={contextOptions}>
      <SettingsCard
        title="Your own location fields"
        description="Extra details you want to record against every location — a site manager, a job number, anything you track. They appear on each Location Details page and can be added to exports."
        status={
          customFields.length
            ? `${customFields.length} of your own ${customFields.length === 1 ? 'field' : 'fields'}`
            : 'Built-in fields only'
        }
        statusTone={customFields.length ? 'info' : 'off'}
        expanded={props.expanded}
        onExpandedChange={props.onExpandedChange}
      >
        <SafeDndProvider backend={HTML5Backend}>
          <BlockOfFields defaultFields={defaultFields} customFields={customFields} />
        </SafeDndProvider>

        <Typography variant="caption" className={classes.footnote}>
          Vyce’s built-in fields can be reordered but not renamed or deleted. To leave a field out of an
          export, untick it in the Time Log export card below.
        </Typography>
      </SettingsCard>

      <DeleteDialog
        isOpen={showDeleteDialog}
        fieldName={fieldName}
        onClose={closeDeleteDialog}
        onClick={deleteCustomField}
      />
    </CustomDetailsFieldsProvider>
  );
};
